import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'blackboard-card',
  templateUrl: './blackboard-card.component.html',
  styleUrls: ['./blackboard-card.component.css']
})
export class BlackboardCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
